import { sanitizeText } from './textSanitizer';

/**
 * Utilitário para corrigir distorções de caracteres e acentuação de arquivos/bancos legados
 * (ex: ?? -> Á, É, Í, Ó, Ú, Ã, Ç, etc.)
 */
export function fixEncodingIssues(text: string | null | undefined): string {
  return sanitizeText(text);
}
